<template>
  <div>
    <el-drawer :visible.sync="languageSetupInside" :title="$t('languageAll')" size="85%" class="search-dialog" :with-header="false" :modal="false" @close="dialog_close('languageSetup')">
        <!-- <div class="search-header">
            <div class="search-center">
                <div class="search-back" @click="dialog_close('languageSetup')">
                  <i class="el-icon-arrow-left" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;"></i>
                </div>
                <div class="search-title">{{$t('languageAll')}}</div>
                <div class="search-close"></div>
            </div>
        </div> -->
        <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
          <i class="el-icon-arrow-left" @click="dialog_close('languageSetup')" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;"></i>
          <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('languageAll')}}</div>
        </div>
        <div class="search-line">
            <div class="search-center">
            <div style="margin:0px 15px;">{{$t('allLanguages')}}</div>
            </div>
        </div>
        <div class="search-main">
            <div class="search-main-line">
                <div class="search-center" @click="languageSwitchSetUp('zh', 1)">
                    <div class="search-main-line-left">
                        <div><img src="https://res.roompai.com/static/img/home/china.png" alt=""></div>
                        <div>简体中文</div>
                    </div>

                    <div class="search-main-line-right">
                        <i class="el-icon-check check-color" v-if="webLanguageSetUp === '简体中文'"></i>
                    </div>
                </div>
            </div>
            <div style="clear:both"></div>

            <div class="search-main-line">
                <div class="search-center" @click="languageSwitchSetUp('en', 1)">
                    <div class="search-main-line-left">
                        <div><img src="https://res.roompai.com/static/img/home/english.png" alt=""></div>
                        <div>English</div>
                    </div>

                    <div class="search-main-line-right">
                        <i class="el-icon-check check-color" v-if="webLanguageSetUp === 'English'"></i>
                    </div>
                </div>
            </div>
        </div>
        <div style="clear:both"></div>
    </el-drawer>
    <div style="clear:both"></div>

    <el-drawer :visible.sync="currencySetupInside" :title="$t('currency')" size="85%" class="search-dialog" :with-header="false" :modal="false" @close="dialog_close('currencySetup')">
        <!-- <div class="search-header">
            <div class="search-center">
                <div class="search-back" @click="dialog_close('currencySetup')"> <i class="el-icon-arrow-left"></i> </div>
                <div class="search-title">{{$t('currency')}}</div>
                <div class="search-close"></div>
            </div>
        </div> -->
        <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
          <i class="el-icon-arrow-left" @click="dialog_close('currencySetup')" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;"></i>
          <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('currency')}}</div>
        </div>
        <div class="search-line">
            <div class="search-center">
                <div style="margin:0px 15px;">{{$t('allCurrency')}}</div>
            </div>
        </div>
        <div class="search-main">
            <div class="search-main-line" v-show="currencyCNYShow">
                <div class="search-center" @click="currencySwitchSetUp('CNY', 1)">
                    <div class="search-main-line-left">
                        <div>{{$t('chineseYuan')}}（CNY）</div>
                    </div>

                    <div class="search-main-line-right">
                        <i class="el-icon-check check-color" v-if="webCurrencySetUp === 'CNY'"></i>
                    </div>
                </div>
                <div style="clear:both"></div>
            </div>
            <div class="search-main-line" v-show="currencyUSDShow">
                <div class="search-center" @click="currencySwitchSetUp('USD', 1)">
                    <div class="search-main-line-left">
                        <div>{{$t('usDollar')}}（USD）</div>
                    </div>

                    <div class="search-main-line-right">
                        <i class="el-icon-check check-color" v-if="webCurrencySetUp === 'USD'"></i>
                    </div>
                </div>
                <div style="clear:both"></div>
            </div>
        </div>
        <div style="clear:both"></div>
    </el-drawer>
    <div style="clear:both"></div>

  </div>
</template>

<script>
export default {
  name: 'publicSetup',
  props: ['languageSetup', 'webLanguage', 'currencySetup', 'webCurrency'],
  data () {
    return {
      languageSetupInside: false,
      currencySetupInside: false,
      currencyCNYShow: true,
      currencyUSDShow: true,
      input_date: '',
      languageSetData: '',
      webLanguageSetUp: '',
      webCurrencySetUp: ''
    }
  },
  watch: {
    languageSetup: function (news, olds) {
      this.languageSetupInside = news
      if (news === true) {
        this.currencySetupInside = false
      }
    },
    currencySetup: function (news, olds) {
      this.currencySetupInside = news
      if (news === true) {
        this.languageSetupInside = false
      }
    }
  },
  created () {
  },
  mounted () {},
  methods: {
    dialog_close: function (type) {
      var data = {}
      if (type === 'languageSetup') {
        data = {
          'type': type,
          'languageSetData': this.languageSetData
        }
      } else {
        data = {
          'type': type,
          'currencySetData': this.webCurrencySetUp
        }
      }
      this.$emit('closepop', data)
    },
    languageSwitchSetUp: function (type, handle) {
      var languageOld = this.common.languageSet(this)

      // 切换语言
      this.$i18n.locale = type
      if (type === 'zh') {
        this.webLanguageSetUp = this.$t('language.zh')
      } else if (type === 'en') {
        this.webLanguageSetUp = this.$t('language.en')
      }
      localStorage.setItem('languageSet', this.$i18n.locale)
      this.languageSetData = this.$i18n.locale
      var urlpath = this.common.routePath(this.$route.path)
      if (urlpath.indexOf('HotelList') !== -1 || urlpath.indexOf('HotelDetail') !== -1) {
        var query = JSON.parse(JSON.stringify(this.common.linkQuerys))
        query.language = this.$i18n.locale
        // this.$router.push({path: this.common.routePath(this.$route.path), query: query})
        var newQuerys = this.common.linkEncode(query, 'obj')
        this.$router.push({path: this.common.routePath(this.$route.path), params: {'querys': newQuerys}})
      }

      // 点击之后跳转当前页
      if (handle === 1 && languageOld !== type) {
        var data = {
          'type': type,
          'currencySetData': this.languageSetData
        }
        this.$emit('closepop', data)
      }
    },
    currencySwitchSetUp: function (type, handle) {
      var currencyOld = this.common.currencySet(this)

      // 切换币种
      this.webCurrencySetUp = type
      localStorage.setItem('currencySet', type)
      var urlpath = this.common.routePath(this.$route.path)
      if (urlpath.indexOf('HotelList') !== -1 || urlpath.indexOf('HotelDetail') !== -1) {
        var query = JSON.parse(JSON.stringify(this.common.linkQuerys))
        query.currency = type
        // this.$router.push({path: this.common.routePath(this.$route.path), query: query})
        var newQuerys = this.common.linkEncode(query, 'obj')
        this.$router.push({path: this.common.routePath(this.$route.path), params: {'querys': newQuerys}})
      }

      // 点击之后跳转当前页
      if (handle === 1 && currencyOld !== type) {
        var data = {
          'type': type,
          'currencySetData': this.webCurrencySetUp
        }
        this.$emit('closepop', data)
      }
    }
  }
}
</script>

<style scoped>
  .search-dialog{width:100%;min-height:900px;}
  .check-color{color:#0096F9;}
  /*.search-dialog div{overflow:hidden;}*/

  .search-dialog .search-header{width:100%;min-height:50px;background:rgba(79, 76, 76, 1);line-height:50px;text-align:center;font-size:16px;color:white;}
  .search-dialog .search-center{width:95%;height:100%;margin:0 auto;}
  .search-dialog .search-header .search-center .search-back{width:15%;height:100%;float:left;font-size:25px;text-align:left;}
  .search-dialog .search-header .search-center .search-close{width:15%;height:100%;float:left;}
  .search-dialog .search-header .search-center .search-title{width:70%;height:100%;float:left;}
  .search-dialog .search-line{width:100%;min-height:40px;background:white;line-height:40px;text-align:left;font-size:13px;background:#DCDFE2;}
  .search-dialog .search-line span{margin-left:2%;}

  /* 目的地 */
  .search-dialog .search-main{width:100%;height:100%;}
  .search-dialog .search-main .search-main-line{width:100%;min-height:50px;background:white;text-align:left;font-size:16px;border-bottom: solid 1px #ccc;}
  .search-dialog .search-main .search-main-line .search-main-line-left{width:70%;height:100%;float:left;text-align:left;height:50px;padding-left: 5px;}
  .search-dialog .search-main .search-main-line .search-main-line-left div{float:left;height:100%;font-size:16px;line-height:50px;color:black;padding:0px 10px 0px 10px;}
  .search-dialog .search-main .search-main-line .search-main-line-left div img{width: 30px;height: 20px;margin: 15px 0px;}

  .search-dialog .search-main .search-main-line .search-main-line-right{width:20%;height:100%;float:right;text-align:right;line-height:50px;height:50px;font-size: 20px;padding-right:10px;}

  /* 日历 */
  .search-dialog .search-header-date{width:100%;min-height:50px;background: rgba(79, 76, 76, 1);line-height:50px;text-align:center;font-size:16px;color:white;position:fixed;top:0px;left:0px;}
  .search-dialog .search-header-date .search-center .search-back{width:15%;height:100%;float:left;font-size:25px;text-align:left;}
  .search-dialog .search-header-date .search-center .search-close{width:15%;height:100%;float:left;}
  .search-dialog .search-header-date .search-center .search-title{width:70%;height:100%;float:left;}

  .search-dialog .search-header-date .search-main-line{width:100%;height:80px;background: rgba(79, 76, 76, 1);color:white;}
  .search-dialog .search-header-date .search-main-line .search-main-line-left{width:45%;height:100%;float:left;}
  .search-dialog .search-header-date .search-main-line .search-main-line-center{width:10%;height:100%;float:left;line-height:80px;}
  .search-dialog .search-header-date .search-main-line .search-main-line-right{width:45%;height:100%;float:left;}
  .search-dialog .search-header-date .search-main-line .search-main-line-date{width:50%;height:100%;text-align:right;float:left;}
  .search-dialog .search-header-date .search-main-line .search-main-line-month{width:50%;height:100%;text-align:left;float:right;}
  .search-dialog .search-header-date .search-main-line .search-main-line-check{width:100%;height:50%;font-size:12px;}
  .search-dialog .search-header-date .search-main-line .search-main-line-month .search-main-line-monthWork{margin-left:5px;}
  .search-dialog .search-header-date .search-main-line .search-main-line-checkday{width:100%;height:50%;font-size: 40px;line-height: 30px;}
  .search-dialog .search-header-date .search-main-line .search-main-line-checkday .search-main-line-checkday-div{width:100%;height:50%;font-size:14px;line-height:17px;}
  .search-dialog .search-header-date .search-main-line-checkday-month,.search-main-line-check{color:#eee;}

  .search-dialog .search-header-date .search-main-date-week{width:100%;height:30px;line-height:30px;background:rgba(79, 76, 76, 1);color:white;margin:0 auto;}
  .search-dialog .search-header-date .search-main-date-week div{width:14.285%;height:100%;float:left;font-size: 12px;color: #eee;}
  .search-dialog .search-month-date{width:100%;margin:0 auto;text-align:center;margin-top:160px;margin-bottom: 15px;}
  .search-dialog .search-month-date .search-month-one{}
  .search-dialog .search-month-date .search-main-date-month-title{font-size:12px;background:#eee;font-weight:bold;color: #777;width:100%;height:100%;}
  .search-dialog .search-month-date .search-main-date-week .search-main-date-day{width:14.285%;height:40px;line-height:40px;float:left;font-size: 12px;color: black;}
  .search-dialog .search-month-date .search-main-date-week .search-main-date-day div{width:100%; height:30px; margin: 5px auto; line-height: 30px;}
  .search-dialog .search-month-date .search-main-date-week .search-main-date-day div span{cursor:pointer;}

  .search-dialog .search-month-button{position: fixed;bottom: 0px;text-align: center;background: white;height: 60px;width: 100%;line-height:60px;}
  .search-dialog .search-month-button button{width: 90%;height: 80%;font-size: 14px;background: rgba(79, 76, 76, 1);color: white;font-weight: 500;border:none;box-shadow: 2px 2px 12px #dcdfe2;border-radius: 4px;}

  .search-main-date-day-active{background: rgba(79, 76, 76, 1);color:white;border-radius: 50%;/* padding: 4px 8px; */width: 30px;height: 100%;font-size: 12px;display: block;margin: 0 auto;}
  .search-main-date-day-left{background:linear-gradient(90deg,#E0F2FF 50%,#fff 50%);}
  .search-main-date-day-right{background:linear-gradient(90deg,#fff 50%,#E0F2FF 50%);}
  .search-main-date-day-all{background:#E0F2FF;}
  .search-main-date-month-top{border-radius: 20px 0px 0px 20px;}
  .search-main-date-month-footer{border-radius: 0px 20px 20px 0px;}

  /* 入住人数 */
  .search-dialog .search-line .search-center .room-num{width:20%;height:100%;float:left;text-align:center;}
  .search-dialog .search-line .search-center .room-title{width:40%;height:100%;float:left;}
  .search-dialog .search-line .search-center .room-button{width:40%;height:100%;float:left;text-align:right;font-size: 25px;}
  .search-button-gray{color:gray;}
  .search-button-blue{color:rgba(79, 76, 76, 1);}
</style>



// WEBPACK FOOTER //
// src/components/public/publicSetup.vue